import { Component, ViewChild } from '@angular/core';
import { BasePage } from '../BasePage';
import { CatalogItem } from '../../models/catalog/catalogItem';
import { FormMode } from '../../core/constants';
import { Catalog } from '../../models/catalog/catalog';
import { CatalogService } from '../../models/catalog/catalogService';
import { StorageService } from '../../core/storage/storageService';
import { EditCatalogComponent } from '../../components/catalog/edit-catalog/edit-catalog.component';
import { MapToStringPropPipe } from '../../core/pipes';

@Component({
  selector: 'app-catalogs-page',
  templateUrl: './catalogs-page.component.html',
  standalone: false,
})
export class CatalogsPageComponent extends BasePage {
  @ViewChild('editCatalogComponent') editCatalogComponent:
    | EditCatalogComponent
    | undefined;
  FormMode = FormMode;

  catalogs: Partial<Catalog>[] = [];
  selectedCatalogId: string = '';
  editingCatalog: boolean = false;
  newCatalog: boolean = false;
  locationId: string = '';
  loading = false;

  constructor(
    private catalogService: CatalogService,
    private storage: StorageService,
  ) {
    super();

    this.editCatalogComponent = undefined as unknown as EditCatalogComponent;
  }

  loadCatalogs(merchantId: string) {
    this.loading = true;
    this.catalogService.getCatalogs(merchantId).then((catalogs) => {
      this.catalogs = catalogs.filter(catalog => !catalog.archived);
    }).finally(() => this.loading = false);
  }
  override ngOnInit(): void {
    super.ngOnInit();
    this.locationId = this.storage.getSelectedLocation()?.id ?? '';
    if (this.locationId) this.loadCatalogs(this.locationId);
  }

  createCatalog() {
    this.editCatalogComponent?.resetForm();
    this.selectedCatalogId = '';
    this.editingCatalog = true;
    this.newCatalog = true;
  }

  editCatalog(catalogId: string) {
    this.editCatalogComponent?.resetForm();
    this.selectedCatalogId = catalogId;
    this.editingCatalog = true;
    this.newCatalog = false;
  }

  archiveCatalog(catalog: Partial<Catalog>) { 
    const message = `Are you sure you want to archive this catalog (${catalog.name})?`;
    if (confirm(message)) {
      this.catalogService.archiveCatalog(catalog.id!).then(() => {  
        this.handleCatalogSaved();
      });
    }
  }

  handleCatalogSaved() {
    this.selectedCatalogId = '';
    this.editingCatalog = false;
    this.catalogService
      .getCatalogs(this.storage.getSelectedLocation()?.id ?? '')
      .then((catalogs) => {
        this.catalogs = catalogs.filter(catalog => !catalog.archived);
      });
  }

  handleCatalogCancelled() {
    this.selectedCatalogId = '';
    this.editingCatalog = false;
  }
}
